module.exports = __webpack_public_path__ + "img/CS-UL-HD_Overview-Roof_3.1cf86cb0.jpg";